var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 159.705,
    height: 26.41,
    viewBox: "0 0 159.705 26.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_330",
    "data-name": "Groupe 330",
    transform: "translate(-389.738 -35.467)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 6.38,
    height: 6.387,
    transform: "translate(389.738 35.603)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 6.579,
    height: 26.256,
    transform: "translate(462.277 35.603)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_69",
    "data-name": "Groupe 69",
    transform: "translate(389.82 35.467)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_215",
    "data-name": "Trac\\xE9 215",
    d: "M403.944,35.626V50.861c0,3.559-.653,5.129-3.961,5.129-2.835,0-3.776-1.853-3.776-5.129V49.214h-6.361c0,1.386-.013,2.423-.013,3.511,0,7.685,7.558,9.173,10.575,9.173,2.98,0,10.85.153,10.85-12.172v-14.1Z",
    transform: "translate(-389.833 -35.489)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 6.344,
    height: 6.353,
    transform: "translate(153.18 20.056)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_216",
    "data-name": "Trac\\xE9 216",
    d: "M557.215,61.9V46.662c0-3.559.653-5.128,3.96-5.128,2.835,0,3.777,1.852,3.777,5.128v1.646h6.36c0-1.386.012-2.422.012-3.51,0-7.685-7.557-9.173-10.573-9.173-2.981,0-10.85-.153-10.85,12.172V61.9Z",
    transform: "translate(-411.701 -35.489)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_217",
    "data-name": "Trac\\xE9 217",
    d: "M488.631,41.778c1.879,1.326,1.6,3.487,1.6,6.007v14.1h7.314V46.65c0-3.558,1.19-5.5,4.543-5.5,3.155,0,4.23,2.225,4.23,5.5V61.883h6.974c0-14.971.012-16.007.012-17.1,0-9.337-7.888-9.173-10.9-9.173h-5.36v1.857l-1.927-1.93H483.278v6.632c2.256-1.629,4.331-1.191,5.353-.4",
    transform: "translate(-402.599 -35.477)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_218",
    "data-name": "Trac\\xE9 218",
    d: "M432.475,43.764c0-2.813-1.545-3.577-4.656-3.577-3.542,0-4.149,2.31-4.352,3.788h-6.832c.81-7.772,7.977-8.508,12.045-8.508,3.8,0,10.728,1.1,10.728,7.343V61.877h-4.851l-2.205-2.164v2.164h-8.378c-4.048,0-8.2-1.852-8.2-7.1,0-4.959,3.34-7.315,7.783-7.894l6.376-.906c.237-.064.419-.093.6-.133l-.024,4.145a26.334,26.334,0,0,1-2.843.544c-2.632.429-4.808,1.049-4.808,3.814a3.02,3.02,0,0,0,3.289,3.052c3.4,0,6.326-1.185,6.326-5.007V43.764Z",
    transform: "translate(-393.377 -35.467)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_219",
    "data-name": "Trac\\xE9 219",
    d: "M536.159,43.764c0-2.813-1.544-3.577-4.655-3.577-3.542,0-4.149,2.31-4.353,3.788H520.32c.811-7.772,7.978-8.508,12.045-8.508,3.794,0,10.728,1.1,10.728,7.343V61.877h-4.852l-2.205-2.164v2.164h-8.379c-4.048,0-8.2-1.852-8.2-7.1,0-4.959,3.34-7.315,7.783-7.894l6.377-.906c.236-.064.419-.093.6-.133l-.024,4.145a26.24,26.24,0,0,1-2.841.544c-2.633.429-4.809,1.049-4.809,3.814a3.019,3.019,0,0,0,3.29,3.052c3.4,0,6.324-1.185,6.324-5.007V43.764Z",
    transform: "translate(-407.542 -35.467)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_220",
    "data-name": "Trac\\xE9 220",
    d: "M443.406,35.625,451.84,49.9l3.149-7.783-3.907-6.49Z",
    transform: "translate(-397.152 -35.489)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_221",
    "data-name": "Trac\\xE9 221",
    d: "M450.131,61.9l10.428-26.273h7.183L457.311,61.9Z",
    transform: "translate(-398.07 -35.489)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.09e227c3ba1d9b026016a7079c35a631.svg";
export { ForwardRef as ReactComponent };